import { ReactNode } from "react";

interface RoutesWrapper {
  children: ReactNode;
}

export const RoutesWrapper = ({ children }: RoutesWrapper) => {
  return (
    <div className="flex min-h-screen flex-col" style={{ paddingLeft: 'var(--app-padding-x, 20px)', paddingRight: 'var(--app-padding-x, 20px)' }}>
      {children}
    </div>
  );
};
